import {Injectable} from '@angular/core';
import {CustomHttp} from "../core/http-custom/http-custom.service";
import {Observable} from "rxjs";

@Injectable()
export class UserPermissionsService {

  constructor(private _http: CustomHttp) {
  }

}
